import React from 'react';

/**
 * The visible "Share" pill of the trip/journey headers: the visitor views
 * (SharedNavActions in visitor.tsx) and the owner's journey detail on desktop,
 * next to the ⋮ kebab, which keeps its own Share row. Outlined green;
 * `compact` collapses it to an icon-only circle for narrow screens.
 */
const ShareButton: React.FC<{ onClick: () => void; compact?: boolean; ariaLabel?: string }> = ({
  onClick,
  compact = false,
  ariaLabel = 'Share this trip',
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={ariaLabel}
    style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
      padding: compact ? 0 : '7px 14px',
      width: compact ? 36 : undefined, height: compact ? 36 : undefined,
      borderRadius: 999, border: '1px solid rgba(21,122,85,0.45)',
      background: '#ffffff', color: '#157a55', fontSize: 13, fontWeight: 700,
      cursor: 'pointer', flexShrink: 0,
    }}
  >
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3v12M12 3l-4 4M12 3l4 4M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    {!compact && <span>Share</span>}
  </button>
);

export default ShareButton;
